import React,{useEffect,useState,useRef} from "react"
import { makeStyles } from 'tss-react/mui';
import { connect } from "react-redux"
import { Routes, Route } from "react-router-dom";
import { withRouter } from "../utils/router";
import {
  resetSession,
  createSession,
  checkLocalSession,
} from "../store/features/session/sessionSlice"
import {
  setNotifications,
  setConversationNotifications,
  setNotificationsLoading,
} from "../store/features/notification/notificationSlice"
import { setPhonebook } from "../store/features/phonebook/phonebookSlice"
import { setExternalPhonebook } from "../store/features/phonebook/externalPhonebookSlice"
import { setPersonalPhonebook } from "../store/features/phonebook/personalPhonebookSlice"
import { setCalls } from "../store/features/calls/callSlice"
import { setVoicemails } from "../store/features/voicemails/voicemailSlice"
import { setSmsConversations } from "../store/features/smsConversations/smsConversationsSlice"
import { setFaxes } from "../store/features/faxes/faxSlice"
import { setRecordings } from "../store/features/recordings/recordingSlice"
import { setConferences } from "../store/features/conferences/conferenceSlice"
import MCLAppBar from "../components/appbar"
import UserProfile from "./profile"
import SipHelp from "../components/sipHelp"
import Notifications from "./notifications"
import {
  getPhonebook,
  getExternalPhonebook,
  getPersonalPhonebook,
  getConferences,
} from "../utils/utils"
import { refreshNotifications, parseUnreadMessages, loadSmsConversations } from "../utils/notifications"
import { useSmsSocket } from "../utils/smsSocket"
import CallView from "./callView"
// import JournalView from "./journalView"
import VoicemailView from "./voicemailView"
import ContactsView from "./contactsView"
import ConferenceView from "./conferenceView"
import AppSettingsView from "./appSettingsView"
import AdminView from "./adminView"
import FaxView from "./faxView"
import SmsView from "./smsView"
import { WebRtcContextJsSIP } from "../index"
// import DialerStatusGlobal from "../components/dialerStatusGlobal"

const mapDispatchToProps = {
  setPhonebook,
  setExternalPhonebook,
  setPersonalPhonebook,
  resetSession,
  checkLocalSession,
  createSession,
  setCalls,
  setVoicemails,
  setSmsConversations,
  setFaxes,
  setRecordings,
  setConferences,
  setNotifications,
  setConversationNotifications,
  setNotificationsLoading,
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    fontSize: "1rem",
  },
  main: {
    flexGrow: 1,
    maxWidth: "100vw",
    maxHeight: "var(--app-vh)",
    height: "100%",
    [theme.breakpoints.up("md")]: {
      overflow: "hidden",
      height: "var(--app-vh)",
    },
  },
  hidden: {
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
}));

// Catch the window unload to handle properly page refresh
const useWindowUnloadEffect = (handler, callOnCleanup) => {
  const cb = useRef()
  cb.current = handler

  useEffect(() => {
    const handler = () => cb.current()
    window.addEventListener('beforeunload', handler)

    return () => {
      if (callOnCleanup) {
        handler()
      }
      window.removeEventListener('beforeunload', handler)
    }
  }, [callOnCleanup])
}

const Dashboard = (props)=> {
  const { classes, cx } = useStyles();
  let count=0;
  const {
    setPhonebook,
    setExternalPhonebook,
    setPersonalPhonebook,
    session,
    lastServer,
    setCalls,
    setVoicemails,
    setSmsConversations,
    setFaxes,
    setRecordings,
    setConferences,
    resetSession,
    history,
    setNotifications,
    setConversationNotifications,
    setNotificationsLoading,
    profileImage,
    voip,
    voipX,
    location,
    services,
  } = props;
  // eslint-disable-next-line
  const [imageHash, setImageHash] = useState(Date.now());
  const [photo, setPhoto] = useState("");

  const webRtcContextJsSIP = React.useContext(WebRtcContextJsSIP);
  if (voip.active === 'yes' && voipX ) {
    webRtcContextJsSIP.startSipStack( voip.private_id, 
                                      voip.public_id, 
                                      voip.contact_uri, 
                                      voip.display_name, 
                                      voip.registrar_server,
                                      voip.wss, 
                                      voipX );
  }

  useWindowUnloadEffect(() => webRtcContextJsSIP.stopSipStack(), true)

  // Live SMS updates on every page of the dashboard: any SMS event reloads the
  // conversations and the unread counts, which drive the bell and the SMS
  // icon badge. The SMS view reads the same store, so it updates as well.
  const smsEnabled = !(services && services.sms === "no");
  useSmsSocket(
    { server: smsEnabled ? lastServer : "", token: session.token },
    () => {
      loadSmsConversations({ server: lastServer, token: session.token }, setSmsConversations)
        .then((res) => {
          if (res instanceof Error) {
            if (res.message === "Unauthorized") {
              webRtcContextJsSIP.stopSipStack();
              resetSession();
              history.push('/login');
            }
            return;
          }
          setConversationNotifications(parseUnreadMessages(res.Conversations));
        })
        .catch((err) => console.error(err));
    }
  );

  useEffect(()=>{
    if(session.loggedIn)
      setPhoto(
        `https://${session.lastServer}4.admin.my-cloudline.net:9003/${profileImage}?${imageHash}`
      );
    // eslint-disable-next-line
  },[session,profileImage]);

  useEffect(() => {
    if(session.lastServer!==""  && count===0){
      const values = {
        server: lastServer,
        token: session.token,
      };

      refreshNotifications({
        values,
        setters: { setCalls, setFaxes, setRecordings, setVoicemails, setSmsConversations },
        extra: [
          getConferences(values, setConferences),
          getPhonebook(values, setPhonebook),
          getExternalPhonebook(values, setExternalPhonebook),
          getPersonalPhonebook(values, setPersonalPhonebook),
        ],
        setNotifications,
        setNotificationsLoading,
        onUnauthorized: () => {
          webRtcContextJsSIP.stopSipStack();
          resetSession();
          history.push('/login');
        },
      });
    }
    // eslint-disable-next-line
  },[]);

  const handleLogout = ()=>{
    webRtcContextJsSIP.stopSipStack();
    resetSession();
    history.push('/login');
  }

  const pathSegment = location.pathname.split("/")[2];
  const menuItems = [
    "call", "voice", "fax", "contacts", "notifications", "conference"
  ];

  return (
    <div className={classes.root}>
      {/* <DialerStatusGlobal /> */}
      <MCLAppBar logoutFn={handleLogout} userPhoto={photo} />
      <main
        className={
          menuItems.some(item => pathSegment && pathSegment.includes(item))
          ? cx(classes.main, classes.hidden)
          : classes.main
        }
      >
        <div className={classes.toolbar}></div>
        <Routes>
          <Route path="user/profile" element={<UserProfile />} />
          <Route path="user/help" element={<SipHelp title="Help" />} />
          <Route path="notifications/:type/*" element={<Notifications />} />
          {services.call && services.call === "yes" && (
            <Route path="call/:type/*" element={<CallView />} />
          )}
          {services.voicemail && services.voicemail === "yes" && (
            <Route path="voice/:type/*" element={<VoicemailView />} />
          )}
          {services.fax && services.fax === "yes" && (
            <Route path="fax/:type/*" element={<FaxView />} />  
          )}
          {services.contacts && services.contacts === "yes" && (
            <Route path="contacts/*" element={<ContactsView />} />
          )}
          {services.conference && services.conference === "yes" && (
            <Route path="conference/:type/*" element={<ConferenceView />} />
          )}
          {services.sms && services.sms === "yes" && (
            <Route path="sms/:type/*" element={<SmsView />} />
          )}
          {services.admin && services.admin === "yes" && (
            <Route path="admin/:type/*" element={<AdminView />} />
          )}
          <Route path="settings" element={<AppSettingsView />} />
        </Routes>
      </main>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    profileImage: state.user.profileImage,
    calls: state.calls,
    voicemails: state.voicemails,
    faxes: state.faxes,
    recordings: state.recordings,
    conferences: state.conferences,
    session: state.session,
    lastServer: state.session.lastServer,
    notifications: state.notifications,
    voip: state.user.voip,
    voipX: state.session.voipX,
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    services: state.user.webapp.services,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
